import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowDown = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 20 12",
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "m17.4094803.47006853c.5688175-.60227741 1.5181776-.62940199 2.120455-.06058443.5646351.53326647.6237647 1.4009941.1602591 2.00363828l-.0996747.11681675-8.5 8.99999997c-.5571137.5898851-1.47319387.6245843-2.07253893.1040974l-.1085005-.1040974-8.5-8.99999997c-.56881756-.60227741-.54169299-1.55163747.06058443-2.12045503.56463508-.53326646 1.43432325-.54275566 2.0095199-.04559743l.11093513.10618186 7.40947644 7.8449353z" })
});
export default SvgArrowDown;
